import { styled } from '@linaria/react';
import { fonts, layout, semantic, size, space, textStyle } from '../../theme/tokens';

export const ScrollContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-600']};
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding: ${space['space-1000']} 0;

  @media (min-width: ${layout.desktopBreakpoint}) {
    max-width: 545px;
    margin: 0 auto;
    padding-top: ${space['space-1400']};
  }
`;

export const CardStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-800']};
  width: 100%;
`;

export const PlayerRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${space['space-300']};
`;

export const PlayerLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
`;

export const GroupLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
`;

export const OptionSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-800']};
  width: 100%;
`;

export const OptionList = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(0, 1fr);
  gap: ${space['space-300']};
  width: 100%;
`;

export const EmptyNote = styled.p`
  margin: 0;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
`;

export const ErrorRow = styled.div`
  width: 100%;
`;

export const AddGuestRow = styled.div`
  display: flex;
`;

export const NotesStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-600']};
  width: 100%;

  @supports (field-sizing: content) {
    & textarea {
      field-sizing: content;
      box-sizing: content-box;
      width: auto;
      min-height: 3lh;
      resize: none;
    }

    @media (min-width: ${layout.desktopBreakpoint}) {
      & textarea {
        min-height: 2lh;
      }
    }
  }
`;

export const NotesLabel = styled.label`
  font-family: ${textStyle.body.lg.regular.fontFamily};
  font-size: ${textStyle.body.lg.regular.fontSize};
  font-weight: ${textStyle.body.lg.regular.fontWeight};
  line-height: ${textStyle.body.lg.regular.lineHeight};
  letter-spacing: ${textStyle.body.lg.regular.letterSpacing};
  color: ${semantic.text.primary};
`;

export const SectionRule = styled.div`
  width: 100%;
  height: ${size.stroke['stroke-default']};
  flex-shrink: 0;
  background: ${semantic.border.default};
`;
